import {Dispatch} from 'react'
import { State } from "../../reducers";
import { ENDPOINTS } from "../../api/config";
import { generalOpenModalInfo, generalShowLoader, generalOpenModalError, generalOpenToastError } from "../general.actions";
import * as validacionesRegex from '../../utils/strings.utils'
import * as validators from '../../utils/validaciones'
import * as http from '../../api/http'

export const HandleValidationRegex = (e: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
  let {name, value} = e.target
  switch (name) {
    case 'startDate':
      return true;
    case 'endDate':
      return true;
    case 'email':
      if (!validacionesRegex.validarRegexLetras(value)) return false;
      break
    default:
      return false;
  }
  return true;
}

// ==========================================================================================================
// PETICIONES REST
// ==========================================================================================================
export const CerrarPeriodoFiscal = (body: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
  if (getState().general.loader) return
  dispatch(generalShowLoader(true))
  let message = 'Se ha producido un error al realizar el cierre de periodo fiscal'
  return await http
    .post(ENDPOINTS.CIERRE_PERIODO_FISCAL, body)
    .then(async (res: any) => {
      if (res?.errorCode === 0){
        await dispatch(generalOpenModalInfo(res?.message))
        return true
      }
      await dispatch(generalOpenModalError(res?.errors[0]?.Message || message))
      return false
    })
    .catch(async (err: any) => {
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? (err?.response?.data?.errors[0]?.Message ?? message), err?.response?.data?.status))
      return false
    })
    .finally(() => dispatch(generalShowLoader(false)))
}